import { Component } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { Router, ActivatedRoute } from "@angular/router";
import {
  PARAM_STARTUPS_REVIEW_PATH,
  STATUS_TYPE_LIST,
} from "src/app/admin/constants/constants";
import { AbstractListController } from "../../common/abstract-list.component";
import { Reviews } from "src/app/models/review";
import { StartupsReviewService } from "src/app/services/startups_review.service";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DrawerModule } from "primeng/drawer";
import { RatingModule } from "primeng/rating";
import { DataTableComponent } from "../../common/data-table/data-table.component";
import {
  RowAction,
  TableColumn,
  TableFilter,
} from "../../common/data-table/data-table.model";

@Component({
  standalone: true,
  selector: "app-manage-reviews",
  templateUrl: "./manage-reviews.component.html",
  imports: [
    CommonModule,
    FormsModule,
    DrawerModule,
    RatingModule,
    DataTableComponent,
  ],
})
export class ManageReviewsComponent extends AbstractListController<
  Reviews,
  any
> {
  title = "Reviews";
  productDialog = false;

  tableColumns: TableColumn[] = [
    { field: "id", header: "ID", width: "80px" },
    { field: "user_email", header: "Email" },
    {
      field: "is_active",
      header: "Attivo",
      type: "boolean",
      trueTag: { label: "published", severity: "success" },
      falseTag: { label: "unpublished", severity: "danger" },
    },
    { field: "value1", header: "Rating", type: "rating" },
    {
      field: "startups",
      header: "Startup",
      type: "link",
      value: (row) => row.startups?.startup_name,
      link: (row) => ["/admin/startups/edit", row.startups?.id],
    },
  ];

  tableFilters: TableFilter[] = [
    { field: "id", header: "ID", type: "string" },
    { field: "user_email", header: "Email", type: "string" },
    {
      field: "is_active",
      header: "Attivo",
      type: "select",
      options: STATUS_TYPE_LIST,
    },
  ];

  rowActions: RowAction[] = [
    {
      icon: "pi pi-eye",
      tooltip: "Dettagli",
      styleClass: "p-button p-button-options",
      event: "view",
    },
  ];

  editLink = (row: Reviews): any[] => ["/admin/reviews/edit", row.id];

  constructor(
    private startupsReviewsService: StartupsReviewService,
    protected confirmationService: ConfirmationService,
    router: Router,
    route: ActivatedRoute,
  ) {
    super(
      startupsReviewsService,
      confirmationService,
      router,
      route,
      PARAM_STARTUPS_REVIEW_PATH,
    );
    this.useTableFilters = true;
  }

  onAction(e: { event: string; row: Reviews }): void {
    if (e.event === "view") {
      this.item = { ...e.row };
      this.productDialog = true;
    }
  }
}
